<template>
  <div>
    <Header class="fixed top-0 left-0 right-0 z-50" />

    <main class="pt-24 pb-16">
      <div class="container mx-auto px-4 sm:px-6 max-w-4xl">
        <h1 class="text-4xl sm:text-5xl font-barlow-condensed font-medium text-brand mb-8 text-center">
          PRIVACY POLICY
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-slate-600 mb-6 font-bold">
            Effective Date: {{ lastUpdated }}
          </p>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">1. Information We Collect
</h2>
            <p class="text-slate-600">
             When you use <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a>, we may collect the following personal information:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
              <li><span class="font-bold">Name and Email Address</span> (provided via contact forms or opt-in forms).</li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">2. How We Collect Your Information</h2>
            <p class="text-slate-600">
            We collect personal data when you:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
            <li>
            Submit a <span class="font-bold">contact form</span> on our website.
            </li>
            <li>
            Opt-in to receive emails, updates, or other communications from us.
            </li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">3. How We Use Your Information</h2>
            <p class="text-slate-600">
              We use the information we collect to:
            </p>
            <ul class="list-disc pl-6 text-slate-600">
              <li><span class="font-bold">Send marketing emails, updates, and promotional content</span>about our guided meditations and related offerings.
</li>
              <li>Respond to <span class="font-bold">inquiries submitted through our contact form.</span></li>
            </ul>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">4. Data Sharing & Third Parties</h2>
            <p class="text-slate-600">
              We do not share, sell, or rent your personal information to third parties.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">5. Use of Cookies</h2>
            <p class="text-slate-600">
              <span class="font-bold"><a href="https://MeditationCircle.com">MeditationCircle.com</a> does use cookies</span> to enhance your browsing experience, track site analytics, and improve functionality.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">6. Your Data Rights</h2>
            <p class="text-slate-600">
              If you wish to access, update, or delete your personal data, you can contact us at <a href="mailto:support@meditationcircle.com" class="font-bold">support@meditationcircle.com</a>.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">7. Data Security</h2>
            <p class="text-slate-600">
              We take data protection seriously and implement security measures, including <span class="font-bold">Cloudflare</span> and <span class="font-bold">WPX security</span>, to safeguard your personal information.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">8. Third-Party Tracking & Advertising</h2>
            <p class="text-slate-600">
              We <span class="font-bold">do not</span> allow third-party ads or tracking on our website.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">9. Governing Law</h2>
            <p class="text-slate-600">
              This Privacy Policy is governed by the laws of <span class="font-bold">Arizona, USA</span>.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">10. Updates to This Policy</h2>
            <p class="text-slate-600">
              We may update this Privacy Policy at any time, and changes will be posted on this page. For any questions, contact <a href="mailto:support@meditationcircle.com" class="font-bold">support@meditationcircle.com</a>.
            </p>
          </section>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Footer from '~/components/Footer.vue';
import Header from '~/components/Header.vue';

definePageMeta({
  name: 'privacy'
});

const lastUpdated = ref('March 19, 2025');
const mobileMenuOpen = ref(false);
</script>

<style scoped>
.prose h2 {
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}

.prose p {
  margin-bottom: 1em;
  line-height: 1.7;
}

.prose ul {
  margin-top: 0.5em;
  margin-bottom: 1em;
}

.prose li {
  margin-bottom: 0.5em;
}
</style> 